export const dropdownEllipsisWidth = "var(--button-small-size)";
